export const treatmentHistoryInitialValues = {
  ecog_status: "",                // e.g. "ECOG 1" or "Unknown"
  date_of_start: "",
  date_of_end: "",
  intention_of_treatment: "",
  role_of_treatment: "",
  details: "",
  status_of_treatment: "",

  // Surgery
  date_of_surgery: "",
  primary_site: "",
  surgical_procedure_performed: "",
  surgeon_name: "",
  extent_of_resection: "",
  tumor_margins: "",
  lymph_node_dissection: "",

  // Chemotherapy
  chemo_regimen: "",
  chemo_protocol_with_duration: "",
  chemo_planned_cycles: "",
  chemo_cycles_administered: "",

  // Radiotherapy
  radiotherapy_regimen: "",
  radiotherapy_protocol_name: "",
  radiotherapy_treatment_intent: "",
  radiotherapy_total_dose: "",
  radiotherapy_dose_per_fraction: "",
  radiotherapy_no_of_planned_fractions: "",
  radiotherapy_no_of_fractions_administered: "",
  radiotherapy_treatment_site: "",
  radiotherapy_radiation_modality: "",

  // Targeted therapy
  targeted_therapy_regimen_protocol: "",
  targeted_therapy_treatment_intent: "",
  targeted_therapy_targeted_drug: "",
  targeted_therapy_molecular_target: "",
  targeted_therapy_specific_dose: "",
  targeted_therapy_route_of_administration: "",
  targeted_therapy_planned_cycles: "",
  targeted_therapy_administered_cycles: "",

  // Immunotherapy
  immunotherapy_regimen: "",
  immunotherapy_protocol_name: "",
  immunotherapy_treatment_intent: "",
  immunotherapy_targeted_drug: "",
  immunotherapy_molecular_target: "",
  immunotherapy_specific_dose: "",
  immunotherapy_route_of_administration: "",
  immunotherapy_planned_cycles: "",
  immunotherapy_administered_cycles: "",

  // Hormone therapy
  hormone_therapy_regimen_protocol: "",
  hormone_therapy_treatment_intent: "",
  hormone_therapy_immunotherapy: "", // looks like the example had "No"
  hormone_therapy_mechanism_of_action: "",
  hormone_therapy_specific_dose: "",
  hormone_therapy_route_of_administration: "",
  hormone_therapy_planned_cycles: "",
  hormone_therapy_cycles_administered: "",
};

// Map API GET response to form values (safely)
export const mapTreatmentHistoryResponse = (data) => {
  if (!data) return treatmentHistoryInitialValues;

  const safeDate = (d) => (d ? (d.slice ? d.slice(0, 10) : d) : "");

  return {
    ecog_status: data?.ecog_status || "",
    date_of_start: safeDate(data?.date_of_start),
    date_of_end: safeDate(data?.date_of_end),
    intention_of_treatment: data?.intention_of_treatment || "",
    role_of_treatment: data?.role_of_treatment || "",
    details: data?.details || "",
    status_of_treatment: data?.status_of_treatment || "",

    date_of_surgery: safeDate(data?.date_of_surgery),
    primary_site: data?.primary_site || "",
    surgical_procedure_performed: data?.surgical_procedure_performed || "",
    surgeon_name: data?.surgeon_name || "",
    extent_of_resection: data?.extent_of_resection || "",
    tumor_margins: data?.tumor_margins || "",
    lymph_node_dissection: data?.lymph_node_dissection || "",

    chemo_regimen: data?.chemo_regimen || "",
    chemo_protocol_with_duration: data?.chemo_protocol_with_duration || "",
    chemo_planned_cycles: data?.chemo_planned_cycles || "",
    chemo_cycles_administered: data?.chemo_cycles_administered || "",

    radiotherapy_regimen: data?.radiotherapy_regimen || "",
    radiotherapy_protocol_name: data?.radiotherapy_protocol_name || "",
    radiotherapy_treatment_intent: data?.radiotherapy_treatment_intent || "",
    radiotherapy_total_dose: data?.radiotherapy_total_dose || "",
    radiotherapy_dose_per_fraction: data?.radiotherapy_dose_per_fraction || "",
    radiotherapy_no_of_planned_fractions: data?.radiotherapy_no_of_planned_fractions || "",
    radiotherapy_no_of_fractions_administered: data?.radiotherapy_no_of_fractions_administered || "",
    radiotherapy_treatment_site: data?.radiotherapy_treatment_site || "",
    radiotherapy_radiation_modality: data?.radiotherapy_radiation_modality || "",

    targeted_therapy_regimen_protocol: data?.targeted_therapy_regimen_protocol || "",
    targeted_therapy_treatment_intent: data?.targeted_therapy_treatment_intent || "",
    targeted_therapy_targeted_drug: data?.targeted_therapy_targeted_drug || "",
    targeted_therapy_molecular_target: data?.targeted_therapy_molecular_target || "",
    targeted_therapy_specific_dose: data?.targeted_therapy_specific_dose || "",
    targeted_therapy_route_of_administration: data?.targeted_therapy_route_of_administration || "",
    targeted_therapy_planned_cycles: data?.targeted_therapy_planned_cycles || "",
    targeted_therapy_administered_cycles: data?.targeted_therapy_administered_cycles || "",

    immunotherapy_regimen: data?.immunotherapy_regimen || "",
    immunotherapy_protocol_name: data?.immunotherapy_protocol_name || "",
    immunotherapy_treatment_intent: data?.immunotherapy_treatment_intent || "",
    immunotherapy_targeted_drug: data?.immunotherapy_targeted_drug || "",
    immunotherapy_molecular_target: data?.immunotherapy_molecular_target || "",
    immunotherapy_specific_dose: data?.immunotherapy_specific_dose || "",
    immunotherapy_route_of_administration: data?.immunotherapy_route_of_administration || "",
    immunotherapy_planned_cycles: data?.immunotherapy_planned_cycles || "",
    immunotherapy_administered_cycles: data?.immunotherapy_administered_cycles || "",

    hormone_therapy_regimen_protocol: data?.hormone_therapy_regimen_protocol || "",
    hormone_therapy_treatment_intent: data?.hormone_therapy_treatment_intent || "",
    hormone_therapy_immunotherapy: data?.hormone_therapy_immunotherapy || "",
    hormone_therapy_mechanism_of_action: data?.hormone_therapy_mechanism_of_action || "",
    hormone_therapy_specific_dose: data?.hormone_therapy_specific_dose || "",
    hormone_therapy_route_of_administration: data?.hormone_therapy_route_of_administration || "",
    hormone_therapy_planned_cycles: data?.hormone_therapy_planned_cycles || "",
    hormone_therapy_cycles_administered: data?.hormone_therapy_cycles_administered || "",
  };
};
